import PageLayout from "@/components/aoria/PageLayout";
import Seo from "@/components/aoria/Seo";
import { ORG } from "@/lib/org";

export default function Confidentialite() {
    return (
        <PageLayout testid="confidentialite-page">
            <Seo
                title="Politique de confidentialité · Aoria"
                description="Politique de confidentialité d'Aoria. Collecte, finalités, sous-traitants, durée de conservation et droits RGPD relatifs aux données personnelles."
                path="/confidentialite"
            />
            <article className="max-w-3xl mx-auto px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <span className="eyebrow">Données personnelles</span>
                <h1 className="h1 mt-6 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A]">
                    Politique de confidentialité
                </h1>
                <p className="mt-6 text-[#5C6B7D] leading-relaxed">
                    Cette page décrit la manière dont Aoria collecte, utilise et
                    protège les données personnelles transmises sur le présent
                    site, conformément au Règlement général sur la protection
                    des données (RGPD) et à la loi Informatique et Libertés.
                </p>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Responsable de traitement
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Le responsable du traitement des données collectées sur
                        ce site est l'association <strong>{ORG.name}</strong>,{" "}
                        {ORG.formShort}, dont le siège est situé{" "}
                        {ORG.address.street}, {ORG.address.zip}{" "}
                        {ORG.address.city}, {ORG.address.country}. Pour toute
                        question :{" "}
                        <a
                            href={`mailto:${ORG.email}`}
                            className="link-underline"
                        >
                            {ORG.email}
                        </a>
                        .
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Données collectées et finalités
                    </h2>
                    <ul className="mt-6 divide-y divide-[#E0E1DD] border-y border-[#E0E1DD]">
                        <li className="py-5">
                            <div className="eyebrow">Lettre d'information</div>
                            <p className="mt-2 text-[#1B263B] text-sm leading-relaxed">
                                Adresse e-mail. Finalité : envoi de nos
                                publications et actualités. Base légale :
                                consentement.
                            </p>
                        </li>
                        <li className="py-5">
                            <div className="eyebrow">Contact / Bénévolat</div>
                            <p className="mt-2 text-[#1B263B] text-sm leading-relaxed">
                                Nom, e-mail, domaine d'expertise, message.
                                Finalité : répondre à votre demande ou
                                instruire votre proposition de contribution.
                                Base légale : exécution de mesures
                                pré-contractuelles ou intérêt légitime.
                            </p>
                        </li>
                        <li className="py-5">
                            <div className="eyebrow">Données techniques</div>
                            <p className="mt-2 text-[#1B263B] text-sm leading-relaxed">
                                Données de navigation strictement nécessaires
                                au fonctionnement et à la sécurité du site,
                                ainsi que des données d'audience agrégées (voir
                                page <a className="link-underline" href="/cookies">Cookies</a>).
                            </p>
                        </li>
                    </ul>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Destinataires et sous-traitants
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Les données collectées via les formulaires sont
                        transmises à <strong>Netlify, Inc.</strong>
                        (hébergement et traitement des formulaires) et
                        accessibles à l'équipe d'Aoria. Aucune donnée n'est
                        revendue ni transmise à des tiers commerciaux.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Durée de conservation
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Les données issues des formulaires de contact et de
                        bénévolat sont conservées trois ans à compter du dernier
                        contact. Les adresses inscrites à la lettre
                        d'information sont conservées jusqu'à demande de
                        désinscription.
                    </p>
                </section>

                <section className="mt-14">
                    <h2 className="h2 text-2xl md:text-3xl text-[#0D1B2A]">
                        Vos droits
                    </h2>
                    <p className="mt-4 text-[#1B263B] leading-relaxed">
                        Vous disposez d'un droit d'accès, de rectification,
                        d'effacement, de limitation, d'opposition et de
                        portabilité des données vous concernant, ainsi que du
                        droit de retirer votre consentement à tout moment. Ces
                        droits peuvent être exercés en écrivant à{" "}
                        <a
                            href={`mailto:${ORG.email}`}
                            className="link-underline"
                        >
                            {ORG.email}
                        </a>
                        . Vous pouvez également introduire une réclamation
                        auprès de la CNIL ({" "}
                        <a
                            href="https://www.cnil.fr"
                            target="_blank"
                            rel="noreferrer noopener"
                            className="link-underline"
                        >
                            cnil.fr
                        </a>
                        ).
                    </p>
                </section>
            </article>
        </PageLayout>
    );
}
